import AppRouter from "./routes/AppRouter";
import {useAutoLogin} from './hooks/useAutoLogin';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePaymentAuth } from './routes/ProtectedRoute';

function App() {
    // useAutoLogin();
    const location = useLocation();
    const {setPaymentAuthed} = usePaymentAuth();

    useEffect(() => {
        const paymentAuthWhitelist = [
            '/wallet/charge',
            '/wallet/refund',
            '/wallet/accountManagement',
            '/settlement/withdrawal',
            '/charge/callback',   // 모바일 충전 콜백 — 여기서 리셋하면 돌아올 때 재인증 필요
            '/payment-password',  // 비밀번호 입력 중 리셋 방지
        ];
        if (!paymentAuthWhitelist.includes(location.pathname)) {
            setPaymentAuthed(false);
        }

        // 충전 플로우 이탈 시 chargeReturnPath 정리
        const chargeFlowPaths = ['/wallet/charge', '/payment-password', '/charge/callback'];
        if (!chargeFlowPaths.includes(location.pathname)) {
            sessionStorage.removeItem('chargeReturnPath');
        }
    }, [location.pathname, setPaymentAuthed]);
    return (
        <>
            <AppRouter/>
            <div id="modal-root"></div>
        </>
    );
}

export default App;
